export default __webpack_public_path__ + "static/media/cityscapes.f5cf644b.jpg";